import { Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import { DataGrid } from "@mui/x-data-grid";

import { formatNumber } from "@/features/shared";
import { ProductVariantNameCell } from "@/features/ui";

export const GeneralProductSection = ({ salesRequestProductVariants }) => {
  // Map salesRequestProductVariants to the table row structure
  const rows = salesRequestProductVariants.map((salesRequestProductVariant) => {
    const {
      purchaseOrderProductVariant: {
        sku,
        name,
        costPerUnit,
        discount,
        quantity,
        product: { unitOfMeasurement },
      },
    } = salesRequestProductVariant;

    return {
      id: salesRequestProductVariant.id,
      sku: sku,
      name: name,
      price: costPerUnit,
      quantity: quantity,
      unitOfMeasurement: unitOfMeasurement.name,
      discount: discount,
      totalPrice: quantity * costPerUnit,
    };
  });

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Produk Umum</Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <DataGrid
            getRowHeight={() => "auto"}
            columns={[
              {
                field: "name",
                headerName: "Produk Varian",
                flex: 3,
                renderCell: ({ row: { name, sku } }) => (
                  <ProductVariantNameCell name={name} sku={sku} linkToStock />
                ),
              },
              {
                field: "price",
                headerName: "@Harga",
                type: "number",
                flex: 1,
                valueFormatter: (value) => formatNumber(value),
              },
              {
                field: "quantity",
                headerName: "Kts",
                type: "number",
                flex: 1,
                valueFormatter: (value) => formatNumber(value),
              },
              {
                field: "unitOfMeasurement",
                headerName: "Satuan",
                flex: 1,
              },
              {
                field: "discount",
                headerName: "Diskon",
                type: "number",
                flex: 1,
                valueFormatter: (value) => formatNumber(value),
              },
              {
                field: "totalPrice",
                headerName: "Total",
                type: "number",
                flex: 1,
                renderCell: (params) => (
                  <Typography
                    variant="body2"
                    color={"primary"}
                    sx={{
                      fontWeight: 600
                    }}
                  >
                    {formatNumber(params.row.totalPrice)}
                  </Typography>
                ),
              },
            ]}
            rows={rows}
            initialState={{
              sorting: {
                sortModel: [{ field: "name", sort: "asc" }],
              },
            }}
            hideFooter
            disableColumnMenu
            disableRowSelectionOnClick
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralProductSection.propTypes = {
  salesRequestProductVariants: PropTypes.array.isRequired,
};
